var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C9.03564 40 9.83733e-07 30.9481 6.36063e-07 20.0105C2.87727e-07 9.05186 9.0566 9.83582e-07 20 6.3573e-07C30.9644 2.87211e-07 40 9.05186 40 20.0105C40 30.9481 30.9434 40 20 40Z",
    fill: "#E0E0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5909 28.119C25.1151 28.6219 25.1151 29.481 24.57 30.0258C24.1088 30.4658 23.1863 30.4448 22.6832 29.9629L14.0459 21.7492C13.0396 20.8272 13.0396 19.2348 14.0459 18.2919L22.6832 10.0991C23.2492 9.57526 24.0459 9.53335 24.57 10.0362C25.1151 10.5391 25.1151 11.4192 24.5909 11.922L16.0585 20.01L24.5909 28.119Z",
    fill: "#86868B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryArrow);
export default __webpack_public_path__ + "static/media/galleryArrow.91fe79d66cff1b95b5d796aff0d64661.svg";
export { ForwardRef as ReactComponent };